import React, { useEffect } from 'react';
import { LoginContainer, LoginBox } from '../login/styles';
import Grid from '@mui/material/Grid';
import backgroundLogin from '../../assets/images/bg-min.jpg';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useAuthToken from '../../hooks/useAuthToken';

const VendorLogin = () => {
  const [searchParams] = useSearchParams();
  const [, setAuthToken] = useAuthToken();
  const navigate = useNavigate();

  useEffect(() => {
    const authToken = searchParams.get('token');
    if (!authToken) {
      navigate('/login');
    } else {
      setAuthToken(authToken);
      navigate('/dashboard');
    }
  }, [searchParams]);

  return (
    <LoginContainer maxWidth="xl">
      <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <LoginBox>
          <Grid xs={5}>
            <CircularProgress color="inherit" />
          </Grid>
        </LoginBox>
      </Grid>
      <Grid
        sx={{
          backgroundImage: `url(${backgroundLogin})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          height: '100vh',
        }}
      />
    </LoginContainer>
  );
};

export default VendorLogin;
